import React, { Component } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import DivCarousel from "../components/DivCarousel/DivCarousel";
import "./page.css";
import Card from "../components/Card/Card";
import Footer from "../components/Footer/Footer";
import Map from "../components/Map/Map";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      details: []
    };
  }
  queryData(child) {
    return new Promise(function(resolve, reject) {
      const database = firebase.database();
      const databaseRef = database.ref();
      databaseRef.child(child).on("value", snap => {
        if (snap.val()) {
          resolve(snap.val());
        } else {
          reject("notfound");
        }
      });
    });
  }
  componentDidMount() {
    this.queryData("Port/" + this.props.match.params.org + "/album").then(
      data => {
        this.setState({ items: data });
      },
      error => {
        console.error(error);
      }
    );
    this.queryData("Organizer/" + this.props.match.params.org).then(data => {
      this.setState({ details: data });
    });
  }
  renderContact() {
    if (this.state.details.contact === undefined) {
      return;
    }
    return (
      <div className="renderContact">
        {Object.keys(this.state.details.contact).map((item, i) => {
          return (
            <span key={i}>
              <br />
              {item.toUpperCase() + " : "}
              {this.state.details.contact[item]}
            </span>
          );
        })}
      </div>
    );
  }
  render() {
    const badge = {
      ontime:
        "http://icons.iconarchive.com/icons/graphicloads/flat-finance/256/timer-icon.png",
      experience:
        "http://icons.iconarchive.com/icons/graphicloads/flat-finance/256/diamond-icon.png",
      details:
        "http://icons.iconarchive.com/icons/graphicloads/flat-finance/256/ideas-icon.png"
    };
    if (this.state.items === null) {
      // render in case of not found organizer in port database
      return (
        <div style={{ paddingTop: "100px" }}>
          {" "}
          <h3>
            {this.props.match.params.org} is not partner with Organizemate yet.
          </h3>
          <br />
          <h3>Thank you for using us.</h3>{" "}
        </div>
      );
    } else
      return (
        <div className="App">
          <DivCarousel
            listjson={this.state.items}
            name={this.props.match.params.org}
            details={this.state.details}
          />
          <div style={{ backgroundColor: "#f6f8fa", width: "100%" }}>
            <div className="badgebox">
              <Card
                width="170px"
                title="ประสบการณ์สูง"
                src={badge.experience}
                // src="http://icons.iconarchive.com/icons/seanau/fresh-web/256/Badge-icon.png"
                margin="50px"
              />
              <Card
                width="170px"
                title="ตรงต่อเวลา"
                src={badge.ontime}
                margin="50px"
              />
              <Card
                width="170px"
                title="ละเอียดรอบคอบ"
                src={badge.details}
                margin="50px"
              />
            </div>
          </div>

          <div className="contact">
            <div className="half" style={{}}>
              <h2>Contact</h2>
              {this.renderContact()}
            </div>
            <div className="half" style={{}}>
              <h2>Map</h2>
              <Map location={{ lat: 13.76498, long: 100.498726 }} />
            </div>
          </div>
          <Footer />
        </div>
      );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Pages/port.js